<template>
	<SOSlotModal
		:modal-title="'Ubah Tempat Terdaftar'"
		:modal-id="id"
		@close="close"
	>
		<template v-slot:modal-body>
			<SOInputSelect
				:required="true"
				:title="'Terdaftar di Outlet'"
				:selected="customer.idoutlet"
				:options="optionOutlet"
				:placeholder="'Pilih Outlet'"
				@option-selected="getNamaOutlet"
			/>
			<ErrorMessage
				class="error"
				label="Oultet"
				:validation="$v.customerTemp.idoutlet"
			/>
			<div class="f-semi f-12 f-c-red m-t-4"
			     v-if="optionOutlet.length > 0 && optionOutlet.findIndex(a => a.id === customer.idoutlet) < 0"
			>
				Outlet {{ customer.nama_outlet }} telah disembunyikan
			</div>
		</template>
		<template v-slot:modal-footer>
			<SOButton
				:text="'Simpan'"
				:primary="true"
				:full="true"
				:disable="pageSetting.btn.save.disabled"
				:loading="pageSetting.btn.save.loading"
				@action="update"
			/>
		</template>
	</SOSlotModal>
</template>

<script>
import {mapGetters} from "vuex";
import {required} from "vuelidate/lib/validators";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOButton from "@/so-components/global/ui/SOButton";
import ErrorMessage from "@/component-items/ErrorMessage";

export default {
	name: "CustomerModalUbahOutlet",
	components: {
		SOSlotModal,
		SOInputSelect,
		SOButton,
		ErrorMessage,
	},
	computed: {
		...mapGetters("customerModule", {
			customer: "getDetailCustomer",
		}),
		...mapGetters("outletModule", {
			outlets: "getOutlet",
		}),
	},
	data() {
		return {
			id: "modal-customer-ubah-outlet",
			customerTemp: {},
			optionOutlet: [],
			namaOutlet: "",
			pageSetting: {
				btn: {
					save: {
						disabled: false,
						loading: false,
					}
				}
			}
		}
	},
	validations: {
		customerTemp: {
			idoutlet: {
				required,
			},
		}
	},
	mounted() {
		this.fetchOutlet()
		$("#" + this.id).modal("show");
		this.cloneVar()
	},
	watch: {
		customerTemp: {
			handler: function () {
				this.validate()
			},
			deep: true,
		}
	},
	methods: {
		cloneVar() {
			this.customerTemp = JSON.parse(JSON.stringify(this.customer))
		},
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		async fetchOutlet() {
			const res = await this.$store.dispatch("outletModule/fetchOutletAll")
			if (res.success) {
				for (let i = 0; i < this.outlets.data.length; i++) {
					this.optionOutlet = [...this.optionOutlet, {
						id: this.outlets.data[i].idoutlet,
						text: this.outlets.data[i].nama
					}]
				}
			} else {
				this.$toast.error(res.err)
			}
		},
		validate() {
			this.pageSetting.btn.save.disabled = this.errorValidation()
		},
		errorValidation() {
			this.$v.customerTemp.idoutlet.$touch()
			return this.$v.customerTemp.idoutlet.$invalid
		},
		async update() {
			this.pageSetting.btn.save.disabled = true
			this.pageSetting.btn.save.loading = true
			const res = await this.$store.dispatch("customerModule/updateCustomerOutlet", this.customerTemp)
			this.pageSetting.btn.save.disabled = false
			this.pageSetting.btn.save.loading = false
			if (res.success) {
				this.$toast.success(res.msg)
				this.close()
			} else {
				this.$toast.error(res.err)
			}
		},
		getNamaOutlet(id) {
			let index = this.optionOutlet.findIndex((a) => a.id === id)
			this.customerTemp.idoutlet = id
			this.customerTemp.nama_outlet = this.optionOutlet[index].text
		}
	},
	beforeDestroy() {
		this.$store.commit("outletModule/resetOutlet")
	}
}
</script>